export enum AvailabilityStatus {
    Away = 1,
    Available
}
